import { User } from "interfaces/user";

export interface CaseAction {
  id: number;
  create_user: number;
  create_user_detail: User;
  change_user: number;
  change_user_detail: User;
  create_date: string;
  change_date: string;
  assignee: number | null;
  assignee_detail: User | null;
  case: number;
  case_display_id: string;
  action_status: number;
  action_status_detail: ActionStatusDetail;
  action_type: number;
  action_type_detail: ActionTypeDetail;
  requested_completion_date: string | null;
  description: string;
  scope_of_work: string;
  link_attachments?: number[];
  estimated_completion_date: string | null;
  site: string;
  machine: string;
  component: string;
  is_external: boolean;
  external_id: string | null;
  external_url: string | null;
  external_status: string | null;
  last_updated_externally: string | null;
}

export interface CaseActionsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CaseAction[];
}

/**
 * A minimised version of case action returned from the my_actions endpoint.
 * Should only be used to display a list of actions in the My Actions Page.
 * When more detail is needed either use the case_actions or my_actions endpoint with the id.
 *  */
export interface MyActionListItem {
  id: number;
  action_type: string;
  action_status: string;
  project_id: number | null;
  project_name: string | null;
  requested_completion_date: string | null;
}

export interface ActionStatusDetail {
  id: number;
  name: string;
  order: number;
}

export interface ActionTypeDetail {
  id: number;
  name: string;
  order: number;
}

// Checked with Jon, these are fixed in the backend
export enum CaseActionStatusType {
  Open = 0,
  InProgress = 1,
  Completed = 2,
  Canceled = 3,
  InReview = 5
}

export enum CaseActionType {
  Repair = 0,
  Inspect = 1,
  Regrease = 2,
  Torque = 3,
  Megging = 4
}
